export default {
  token: (state) => state.token,
  refreshToken: (state) => state.refreshToken,
  user: (state) => state.user,
  message: (state) => state.message,
  loggedIn: (state) => state.token !== null,
  userHasThoseRoles: (state, getters) => (targetRoles) => {
    if (targetRoles.length === 0) {
      return true
    }
    if (state.user) {
      const res = state.user.roles.some((role) => {
        return targetRoles.indexOf(role['name']) >= 0
      })
      return res
    }
    return false
  },
  settingParams: (state) => state.settingParams,
  unitLabel: (state) => {
    if (state.settingParams !== null) {
      if (state.settingParams.unit === 'liter') {
        return 'liter'
      } else if (state.settingParams.unit === 'gal') {
        return 'gal'
      }
    }
    return 'liter'
  },
  startPage: (state) => {
    if (state.logoutPage !== null) {
      return state.logoutPage
    } else {
      return '/'
    }
  },
  showStartGuide: (state) => state.showStartGuide,
  locale: (state) => state.locale,
  serviceList: (state) => state.serviceList,
  isCustomerFormat: (state) => {
    if (state.waterSystemDisplayMode === 'customer') return true
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js